import { apiRequest } from "../util/apiUtils";

export const contactList = async (params) => {
  try {
    const res = await apiRequest("get", `contact-us/list`, {
      queries: { ...params, type: "contact" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const contactDetails = async (params) => {
  try {
    const res = await apiRequest("get", `contact-us/detail/${params?.id}`, {});

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const contactAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `contact-us/${payload?.id ? "edit" : "add"}`,
      {
        body: { ...payload, type: "contact" },
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const contactDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `contact-us/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const contactStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `contact-us/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const contactOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `contact-us/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
